import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { ProductPermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { ProductGroupSelection } from "share-components/group-selection/product-group-selection/product-group-selection";
import { ProductGroupSelectionKey } from "share-components/group-selection/product-group-selection/use-product-group-selection";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { AddProduct } from "../add-product/add-product";
import { ProductTable } from "./product-table";

export const ProductList = observer(() => {
  const {
    productManagement: { openNew, pagination, getProducts, queryParams },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getProducts();
  }, [getProducts, pagination]);

  const setProductFilterProp = useCallback(
    (prop: ProductGroupSelectionKey, value: string) => {
      queryParams.setProp(prop as "dealingName" | "name" | "code", value);
    },
    [queryParams],
  );
  return (
    <>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageFilterContainer direction={"row"} spacing={1}>
        <ProductGroupSelection
          dealingNameSelected={queryParams.dealingName}
          nameSelected={queryParams.name}
          codeSelected={queryParams.code}
          setSelectionProp={setProductFilterProp}
          searchWhenRender={false}
          visibleFields={["dealingName", "name", "code"]}
        />
        <XSearchTextField
          label="Mã barcode"
          value={queryParams.barcode}
          onChange={(e) =>
            queryParams.setProp("barcode", e.currentTarget.value)
          }
        />

        <SearchButton asyncAction={onSearch}></SearchButton>
      </PageFilterContainer>
      <PageContentContainer>
        <ProductTable></ProductTable>
      </PageContentContainer>

      <>
        <>{openNew && <AddProduct></AddProduct>}</>
      </>
    </>
  );
});

const Header = observer(() => {
  const {
    productManagement: {
      setProp,
      getProducts,
      queryParams: { showDisabled, setProp: setQueryProps },
    },
  } = useStores();

  const showDisabledHandler = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setQueryProps("showDisabled", checked);
      await getProducts();
    },
    [getProducts, setQueryProps],
  );
  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Quản lý mặt hàng</Typography>
      </Stack>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <FormControlLabel
          control={
            <Checkbox checked={showDisabled} onChange={showDisabledHandler} />
          }
          label="Ngưng sản xuất"
        />
        <AddButton
          accessPermission={[ProductPermission.Create]}
          onClick={() => {
            setProp("openNew", true);
          }}
        >
          Thêm mới
        </AddButton>
      </Stack>
    </>
  );
});
